module.exports = __webpack_public_path__ + "img/img4.66c5f1e9.jpeg";